// AUTO-GENERATED from `bush_3.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 31343,
    "type": "evergreen",
    "bark": {
      "type": "Bark001",
      "tint": 13552830,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 0.5,
        "y": 5
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 66.52173913043478,
        "2": 52.82608695652174,
        "3": 0
      },
      "children": {
        "0": 13,
        "1": 4,
        "2": 4
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0
      },
      "gnarliness": {
        "0": 0.05434782608695654,
        "1": 0.06521739130434778,
        "2": 0.05,
        "3": 0.09
      },
      "length": {
        "0": 10.958695652173914,
        "1": 21.81739130434783,
        "2": 13.130434782608695,
        "3": 5.529347826086957
      },
      "radius": {
        "0": 0.5793478260869566,
        "1": 0.9521739130434783,
        "2": 0.6858695652173914,
        "3": 0.7391304347826086
      },
      "sections": {
        "0": 4,
        "1": 3,
        "2": 3,
        "3": 10
      },
      "segments": {
        "0": 3,
        "1": 3,
        "2": 3,
        "3": 3
      },
      "start": {
        "1": 0.14130434782608695,
        "2": 0.29347826086956524,
        "3": 0
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0.3,
        "1": -0.03260869565217389,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "pine",
      "billboard": "double",
      "angle": 54,
      "count": 3,
      "start": 0.15217391304347827,
      "size": 3.0434782608695654,
      "sizeVariance": 0.45652173913043476,
      "tint": 10339327,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
